export const getModalStyles = (isDarkMode: boolean, colors: any) => {
  return {
    title: {
      fontSize: "1.6rem",
      color: colors.secondary,
    },
    label: {
      fontSize: "1.2rem",
      color: isDarkMode ? "#f0f0f0" : "#201b41",
    },
    input: {
      fontSize: "1.2rem",
      // color: isDarkMode ? "#f0f0f0" : "#201b41",
    },
    placeholder: {
      fontSize: "1.2rem",
      // color: isDarkMode ? "#f0f0f0" : "#201b41",
    },
    content: {
      backgroundColor: colors.primary,
      borderWidth: 1,
      borderColor: colors.border,
      borderStyle: "solid",
      borderRadius: ".5rem",
      padding: "2rem",
    },
    header: {
      backgroundColor: "transparent",
    },
    button: {
      root: {
        backgroundColor: isDarkMode ? "#f0f0f0" : "#201b41",
        color: isDarkMode ? "#201b41" : "#f0f0f0",
        fontWeight: "bold",
        borderRadius: ".5rem",
        fontSize: "1.2rem",
        height: "4rem",
        width: "10rem",
      },
    },
    close: {
      color: isDarkMode ? "#f0f0f0" : "#201b41",
      border: "none",
      outline: "none",
      backgroundColor: "transparent",
    },
  };
};
